export enum TAX_TYPE {
  NON_TAXABLE = "NON_TAXABLE",
  OUT_OF_SCOPE = "OUT_OF_SCOPE",
  NON_GST_SUPPLY = "NON_GST_SUPPLY",
  GST0 = "GST0",
  GST0_1 = "GST0_1",
  GST0_25 = "GST0_25",
  GST1 = "GST1",
  GST1_5 = "GST1_5",
  GST3 = "GST3",
  GST5 = "GST5",
  GST6 = "GST6",
  GST7_5 = "GST7_5",
  GST12 = "GST12",
  GST18 = "GST18",
  GST28 = "GST28",
  GST_40 = "GST_40",
}

export const TAXES = [
  {
    name: "0%",
    value: TAX_TYPE.GST0,
    desc: "",
  },
  {
    name: "0.1%",
    value: TAX_TYPE.GST0_1,
    desc: "",
  },
  {
    name: "0.25%",
    value: TAX_TYPE.GST0_25,
    desc: "",
  },
  {
    name: "1%",
    value: TAX_TYPE.GST1,
    desc: "",
  },
  {
    name: "1.5%",
    value: TAX_TYPE.GST1_5,
    desc: "",
  },
  {
    name: "3%",
    value: TAX_TYPE.GST3,
    desc: "",
  },
  {
    name: "5%",
    value: TAX_TYPE.GST5,
    desc: "",
  },
  {
    name: "6%",
    value: TAX_TYPE.GST6,
    desc: "",
  },
  {
    name: "7.5%",
    value: TAX_TYPE.GST7_5,
    desc: "",
  },
  {
    name: "12%",
    value: TAX_TYPE.GST12,
    desc: "",
  },
  {
    name: "18%",
    value: TAX_TYPE.GST18,
    desc: "",
  },
  {
    name: "28%",
    value: TAX_TYPE.GST28,
    desc: "",
  },
  {
    name: "40%",
    value: "GST_40",
    desc: "",
  },
  // {
  //   name: "Non Taxable",
  //   value: TAX_TYPE.NON_TAXABLE,
  //   desc: "",
  // },
  // {
  //   name: "Out of scope",
  //   value: TAX_TYPE.OUT_OF_SCOPE,
  //   desc: "Supplies on which you don’t charge any GST or include them in the returns",
  // },
  // {
  //   name: "Non - GST Supply",
  //   value: TAX_TYPE.NON_GST_SUPPLY,
  //   desc: "Supplies which do not come under GST such as petroleum products and Liquor",
  // },
];
